import { findMixLineupEntry } from "@/config/mixLineup";
import { cn } from "@/shared/lib";

interface ThreadCreateBoardPickerProps {
  /** 選択肢(総合カタログでONの板slug、ラインナップ順・先頭=アンカー板)。 */
  slugs: readonly string[];
  selectedSlug: string;
  onSelect: (slug: string) => void;
}

/**
 * 総合カタログのスレ立て先の板を選ぶチップ列。
 * スレ寿命上限は板依存のため、選択の切替で寿命表示も追従する。
 */
export const ThreadCreateBoardPicker: React.FunctionComponent<
  ThreadCreateBoardPickerProps
> = ({ slugs, selectedSlug, onSelect }: ThreadCreateBoardPickerProps) => (
  <fieldset className="flex flex-wrap gap-2">
    <legend className="sr-only">スレッドを立てる板</legend>
    {slugs.map((slug) => {
      const entry = findMixLineupEntry(slug);
      const label = entry ? `${entry.emoji} ${entry.label}` : slug;
      const selected = slug === selectedSlug;
      return (
        <button
          key={slug}
          type="button"
          aria-pressed={selected}
          className={cn(
            "rounded-full border px-3 py-1 text-sm transition-colors",
            selected
              ? "border-primary bg-primary text-primary-foreground"
              : "border-border bg-muted text-foreground hover:text-primary",
          )}
          onClick={(): void => onSelect(slug)}
        >
          {label}
        </button>
      );
    })}
  </fieldset>
);
